import React, { useState } from 'react';
import { Box, Typography, Form, Loader } from '@lucid/lego';
import { useLocaleNavigate } from '../../../hooks/useLocaleNavigate';
import { useStore } from '../../../store/store';
import { createClaimFormFields } from './formFields';
import styles from './CreateClaim.module.scss';

const REDIRECT_DELAY = 2000;
const SUCCESS_MESSAGE = 'Claim submitted successfully!';
const VALIDATION_ERROR = 'Please fix the form errors before submitting.';
const REDIRECT_PATH = '/claims-center/track-claim';

const CreateClaim: React.FC = () => {
  const theme = useStore((state) => state.theme);
  const navigate = useLocaleNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [isPending, setIsPending] = useState(false);

  const handleSuccess = (data: unknown) => {
    setErrorMessage(null);
    setIsPending(true);

    // TODO: Implement actual claim submission API call
    // For now, simulate a successful submission
    setTimeout(() => {
      setIsPending(false);
      setSuccessMessage(SUCCESS_MESSAGE);
      setTimeout(() => {
        navigate(REDIRECT_PATH);
      }, REDIRECT_DELAY);
    }, 1000);

    console.log('Claim submitted:', data);
  };

  const handleError = (error: unknown) => {
    console.error('Form validation failed:', error);
    setErrorMessage(VALIDATION_ERROR);
    setSuccessMessage('');
  };

  return (
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        Create Claim
      </Typography>
      <Box pt={8}>
        <Typography variant="body" size="medium" color="gray-5" theme={theme}>
          Submit a new warranty claim for review
        </Typography>
      </Box>
      <Box className={styles.formContent} background={theme === 'dark' ? 'white' : 'black'} mt={32}>
        <Box className={styles.formWrapper}>
          {successMessage && (
            <Box mb={16} pt={12} pb={12} pl={16} pr={16} className={styles.successMessageText}>
              <Typography variant="body" size="medium" color="white" theme={theme}>
                {successMessage}
              </Typography>
            </Box>
          )}
          {errorMessage && (
            <Box mb={16} pt={12} pb={12} pl={16} pr={16} className={styles.errorMessageText}>
              <Typography variant="body" size="medium" color="white" theme={theme}>
                {errorMessage}
              </Typography>
            </Box>
          )}
          {isPending && (
            <Box className="fetchingOverlay">
              <Loader size={32} />
            </Box>
          )}
          <Form
            id="create-claim-form"
            theme={theme === 'dark' ? 'light' : 'dark'}
            formFields={createClaimFormFields()}
            onSuccess={handleSuccess}
            onError={handleError}
            isFluid={true}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CreateClaim;
